import React, { useEffect, useState } from 'react';
import { GLOBAL_NAV_BANNER_ID, initializeBanners } from './Braze';

export const GlobalNavBanner = () => {
  const [isControl, setIsControl] = useState<boolean>();

  useEffect(() => {
    const { isBannerControl } = initializeBanners(GLOBAL_NAV_BANNER_ID);
    setIsControl(isBannerControl);
  }, []);

  if (isControl) return null;
  // This div is required for Braze to insert the banner HTML into
  return <div id={GLOBAL_NAV_BANNER_ID} style={{ width: '100%', maxHeight: '300px' }} />;
};
